"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.readbackByValue = void 0;
const Actions = __importStar(require("../actions"));
const closure_1 = require("../closure");
const Cores = __importStar(require("../core"));
const ctx_1 = require("../ctx");
const Errors = __importStar(require("../errors"));
const Neutrals = __importStar(require("../neutral"));
const readback_1 = require("../readback");
const solution_1 = require("../solution");
const freshen_1 = require("../utils/freshen");
const Values = __importStar(require("../value"));
function readbackByValue(mod, ctx, type, value) {
    switch (value["@kind"]) {
        case "TypedNeutral": {
            /**
               The `type` in `TypedNeutral` are not used.
            **/
            return (0, readback_1.readbackNeutral)(mod, ctx, value.neutral);
        }
        case "Fn": {
            Values.assertTypeInCtx(mod, ctx, type, "Pi");
            // NOTE Perform partial evaluation.
            const name = type.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, type.argType, ctx);
            const ret = Actions.doAp(value, v);
            return Cores.Fn(freshName, (0, readback_1.readback)(mod, ctx, retType, ret));
        }
        case "FnImplicit": {
            Values.assertTypeInCtx(mod, ctx, type, "PiImplicit");
            // NOTE Perform partial evaluation.
            const name = type.retTypeClosure.name;
            const usedNames = [...(0, ctx_1.ctxNames)(ctx), ...(0, solution_1.solutionNames)(mod.solution)];
            const freshName = (0, freshen_1.freshen)(usedNames, name);
            const v = Values.TypedNeutral(type.argType, Neutrals.Var(freshName));
            const retType = (0, closure_1.closureApply)(type.retTypeClosure, v);
            ctx = (0, ctx_1.CtxCons)(freshName, type.argType, ctx);
            const ret = Actions.doApImplicit(value, v);
            return Cores.FnImplicit(freshName, (0, readback_1.readback)(mod, ctx, retType, ret));
        }
        case "Cons": {
            Values.assertTypeInCtx(mod, ctx, type, "Sigma");
            // NOTE Perform partial evaluation.
            const car = Actions.doCar(value);
            const cdr = Actions.doCdr(value);
            const cdrType = (0, closure_1.closureApply)(type.cdrTypeClosure, car);
            return Cores.Cons((0, readback_1.readback)(mod, ctx, type.carType, car), (0, readback_1.readback)(mod, ctx, cdrType, cdr));
        }
        case "Quote": {
            return Cores.Quote(value.data);
        }
        case "Sole": {
            return Cores.Var("sole");
        }
        case "Objekt": {
            Values.assertClazzInCtx(mod, ctx, type);
            return Cores.Objekt((0, readback_1.readbackProperties)(mod, ctx, type, value));
        }
        case "Refl": {
            return Cores.ApImplicit(Cores.ApImplicit(Cores.Var("refl"), (0, readback_1.readbackType)(mod, ctx, value.type)), (0, readback_1.readback)(mod, ctx, value.type, value.value));
        }
        default: {
            throw new Errors.ReadbackError([
                `[readbackByValue] is not implemented for`,
                `  type["@kind"]: ${type["@kind"]}`,
                `  value["@kind"]: ${value["@kind"]}`,
            ].join("\n"));
        }
    }
}
exports.readbackByValue = readbackByValue;
//# sourceMappingURL=readbackByValue.js.map